import { getCookie } from "typescript-cookie";

export function getAuthToken() {
    return getCookie('token');
}

export function headersWithAuth(): Record<string, string> {
    const token = getAuthToken();
    return token ? {
        'Authorization': `Bearer ${token}`
    } : {};
}
